import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import ServicesApi from 'libs/api/website/services';

const useSingleService = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const response = await ServicesApi.show(routeId);
        const data = response.data;

        if (!cancelled) {
          if (data?.success && data.service) {
            setSingleItem({
              ...data.service,
              icon: data.icon ?? data.service.icon,
              icon_name: data.icon_name ?? data.service.icon_name,
              icon_id: data.icon_id ?? data.service.icon_id,
            });
          } else if (data?.service) {
            setSingleItem(data.service);
          } else {
            setSingleItem({});
          }
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleService;
